var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card",style:({
    borderColor: _vm.borderColor || 'white', 
    borderWidth: !!_vm.borderColor ? '3px' : '0'
  })},[(_vm.title)?_c('div',{staticClass:"card-header",style:({backgroundColor: _vm.headerBgColor, color: _vm.headerColor})},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('div',{staticClass:"card-content"},[_vm._t("default")],2),_c('div',{staticClass:"card-footer"},[_vm._t("footer")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }